import script from "./ServiceFeeModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ServiceFeeModal.vue?vue&type=script&setup=true&lang=js"

import "./ServiceFeeModal.vue?vue&type=style&index=0&id=1e564d51&scoped=true&lang=scss"

import exportComponent from "/builds/gu1sQVEd/1/fe-huihui/fed-doctor-helper-ms/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1e564d51"]])

export default __exports__